
import React from 'react'; 
import { useRef } from 'react'; 
import { useSelector } from 'react-redux'

export function InputRadioFilter(props) { 
  const inputRefs = useRef({});
  const { currentUser } = useSelector(state => state.currentUser)
  const handleClick = (value) => (e) => {
    // Если это уже выбранный вариант - сбрасываем
    if (props.value === value) {
      if (props.onChange) {
        props.onChange({
          target: {
            name: props.name,
            value: ''
          }
        });
      }
      // Снимаем визуальное выделение
      if (inputRefs.current[value]) {
        inputRefs.current[value].checked = false;
      }
    } else {
      // Иначе просто позволяем onChange работать как обычно
      if (props.onChange) {
        props.onChange({
          target: {
            name: props.name,
            value: value
          }
        });
      }
    }
  };

  return (
    <>  
     {Object.keys(currentUser).length !== 0 && 
     <> 
      <label className='form__label_course font20Norm colorGrey'>
        <input
          type="radio"
          className='form__input_course'
          name={props.name}
          value='owner'
          checked={props.value === 'owner'}
          onChange={() => {}} // Пустой обработчик
          onClick={handleClick('owner')}
          ref={el => inputRefs.current['owner'] = el}
          id='owner'
        />
        <span className="visible-check item__link"></span>
        Мои рецепты
      </label> 
        <label className='form__label_course font20Norm colorGrey'>
        <input 
          type="radio" 
          value='likes' 
          checked={props.value === 'likes'} 
          className='form__input_course' 
          onChange={() => {}} 
          onClick={handleClick('likes')}
          ref={el => inputRefs.current['likes'] = el}
          name={props.name}
          id='likes' 
        />
        <span className="visible-check item__link"></span>
        Избранные
      </label>
      </>
     }
      <label className='form__label_course font20Norm colorGrey'>
        <input 
          type="radio"  
          value='feast'  
          checked={props.value === 'feast'}  
          className='form__input_course' 
          onChange={() => {}} 
          onClick={handleClick('feast')}
          ref={el => inputRefs.current['feast'] = el}
          name={props.name}
          id='feast' 
        />
        <span className="visible-check item__link"></span>
        Праздничные
      </label>
    </>
  );
}